import { Avatar, Divider, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Formik } from "formik";

import { StyledVehicleDetailInfo } from ".";
import { DateTimeRow, DateTimeInputWrapper, DateTimeInput, RepeatingFrequencyWrapper, RepeatingGridContainer, EndMethodContainer, EndMethodLabel, EndMethodNumberInput, EndMethodDateInput, ExecutionDateContainer, ExecutionDateLabel, ExecutionDateOption, ExecutionDateWrapper, DaysOfWeekContainer, DayToggleButton } from "src/Components/styles";
import { borrowingInstrumentSchema, formatDateOfBirth, linkImage, useWindowDimensions, linkAvatar } from "@utils";
import { AppDateRangePicker, AppCustomeSelect, WideButton, AppTextArea, AppInput } from "..";
const queryString = require("query-string");
import moment from "moment";
import "moment-timezone";
import { LABEL_CONSTRUCTIONSITE, PLACEHOLDER_CONSTRUCTIONSITE } from "@configs";
import { selectAuth, useAppSelector } from "@redux";
import { useTargetHistory } from "@utils";
import { useConstructionSelectionHistories } from "src/Utils/Hooks/useConstructionSelectionHistories";
import { calculateEndDate } from "src/Utils/CalculateDates";
import { calculateReturnTime } from "src/Utils/CalculateReturnTime";
import { vehicleApi } from "@api";
import { calculateReservationsInMonth } from "src/Utils/CalculateRecurringBorrowings";
import { useParams } from "react-router-dom";

interface IProps {
  product?: any;
  selectedDate?: any;
  handleOnSubmit: (values: any) => void;
}

const repeatingFrequencyOptions = [
  {label: "選択", value: "none", suffix: ""},
  {label: "毎日", value: "daily", suffix: "日"},
  {label: "毎週", value: "weekly", suffix: "週間"},
  {label: "毎月", value: "monthly", suffix: "ヶ月"},
  {label: "毎年", value: "yearly", suffix: ""}, // there can't be a gap (frequency) for yearly
] as const;
type RepeatingFrequency = typeof repeatingFrequencyOptions[number]["value"];

// 曜日
const repeatingDayOptions = [
  { value: 1, shortLabel: "月", label: "月曜日" },
  { value: 2, shortLabel: "火", label: "火曜日" },
  { value: 3, shortLabel: "水", label: "水曜日" },
  { value: 4, shortLabel: "木", label: "木曜日" },
  { value: 5, shortLabel: "金", label: "金曜日" },
  { value: 6, shortLabel: "土", label: "土曜日" },
  { value: 7, shortLabel: "日", label: "日曜日" },
];

const repeatingMonths = [
  { value: 1, label: "1月" },
  { value: 2, label: "2月" },
  { value: 3, label: "3月" },
  { value: 4, label: "4月" },
  { value: 5, label: "5月" },
  { value: 6, label: "6月" },
  { value: 7, label: "7月" },
  { value: 8, label: "8月" },
  { value: 9, label: "9月" },
  { value: 10, label: "10月" },
  { value: 11, label: "11月" },
  { value: 12, label: "12月" },
];

const repeatingWeekOptions = [
  { value: 1, label: '第一' },
  { value: 2, label: '第二' },
  { value: 3, label: '第三' },
  { value: 4, label: '第四' },
  { value: -1, label: '最終' }
];

const endDateOptions = [
  {label: "指定なし", value: "none"},
  {label: "回数指定", value: "occurrences"},
  {label: "日付指定", value: "date"},
];

export const VehicleDetailInfoComponent = (props: IProps) => {
  const { product, selectedDate, handleOnSubmit } = props;
  //console.log("VehicleDetailInfoComponent product:", product);
  
  const { id: vehicleId } = useParams<{ id: string }>();
  const parsed = queryString.parse(location.search);
  const queryStartDate = parsed.startDate ? moment(parsed.startDate).format("YYYY-MM-DD") : parsed.start ? moment(parsed.start).format("YYYY-MM-DD") : moment(new Date()).format("YYYY-MM-DD");
  const queryStartTime = parsed.startTime as string | undefined;
  const queryStart = queryStartTime ? moment(`${parsed.startDate} ${queryStartTime}`, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD HH:mm:ss") : moment(parsed.startDate, "YYYY-MM-DD").format("YYYY-MM-DD");
  console.log("queryStartTime:", queryStartTime);
  const queryEndDate   = parsed.endDate ? moment(parsed.endDate).format("YYYY-MM-DD") : null;
  const queryEndTime   = parsed.endTime as string | undefined;
  const defaultStartTime = queryStartTime ? queryStartTime : null;
  const defaultEndTime = queryEndTime || null;

  const queryEffectRange = parsed.effectRange || "";
  const initialReservationRepeating = (queryEffectRange === "all" || queryEffectRange === "future") ? true : false;
  const newReservation = !parsed.reservationId;
  const normalReservation = (parsed.reservationId && queryEffectRange === "") ? true : false;
  const canSelectNormal = (newReservation || normalReservation || queryEffectRange === "this") ? true : false;
  const canSelectRecurring = (newReservation || queryEffectRange === "all" || queryEffectRange === "future") ? true : false;
  const queryReservationId = parsed.reservationId || "";

  const [optionSiteConstructions, setOptionSiteConstructions] = React.useState<any>([]);
  const { idConstuctionEmployeeSearch } = useAppSelector(selectAuth);

  const [comment, setComment] = useState<string>("");
  const [reservationRepeating, setReservationRepeating] = useState<boolean>(initialReservationRepeating);
  const [startDate, setStartDate] = useState<string>(queryStartDate);
  const [startTime, setStartTime] = useState<string>(defaultStartTime || "09:00");
  const [endDate, setEndDate] = useState<string>(queryEndDate || queryStartDate);
  const [endTime, setEndTime] = useState<string>(defaultEndTime || "18:00");

  const [repeatingFrequency, setRepeatingFrequency] = useState<RepeatingFrequency>("none");
  const [repeatingGap, setRepeatingGap] = useState<number>(1);
  const [repeatingMonth, setRepeatingMonth] = useState<number>(1);
  const [repeatingDaysOfWeek, setRepeatingDaysOfWeek] = useState<number[]>([]);
  const [repeatingMonthMethod, setRepeatingMonthMethod] = useState<"date" | "week">("date");
  const [repeatingMonthWeek, setRepeatingMonthWeek] = useState<number>(1);
  const [repeatingMonthDay, setRepeatingMonthDay] = useState<number>(1);
  const [repeatingEndMethod, setRepeatingEndMethod] = useState<string>("none");
  const [repeatingOccurrences, setRepeatingOccurrences] = useState<number>(1);
  const [repeatingEndDate, setRepeatingEndDate] = useState<string>(queryStartDate); // this will be ignored if currentValues.repeatingEndMethod === "none"

  const validRepeatingInputs = (
    repeatingFrequency !== "none" &&
    (repeatingFrequency !== "daily" || repeatingGap > 0) &&
    (repeatingFrequency !== "weekly" || repeatingDaysOfWeek.length > 0) &&
    (repeatingFrequency !== "monthly" || (repeatingMonthMethod === "date" || (repeatingMonthMethod === "week" && repeatingMonthWeek && repeatingMonthDay))) &&
    (repeatingFrequency !== "yearly" || repeatingMonth > 0)
  );


  const auth = useAppSelector(selectAuth);
  const id = auth.userInfo?.id;
  const { constructionList, fetchConstructionList, storeConstructionSelection } = useConstructionSelectionHistories(id ?? 0);

  //component states
  const [dateRate, setDateRate] = React.useState<any>({
    startDate: new Date(),
    endDate: new Date(),
  });

  React.useEffect(() => {
    setOptionSiteConstructions(constructionList);
  },[constructionList]);

  const updateEndDate = (currentValues: any = {}) => {
    // First, we need to know how we set the end date
    // It might be endless, by occurrences, or by a fixed end date
    // If it's endless, or by date, we don't need to calculate anything, the end date should stay as is
    if (currentValues.repeatingEndMethod === "none") {
      //setRepeatingEndDate(null);
      return; // endless, no end date
    } else if (currentValues.repeatingEndMethod === "date") {
      return; // fixed end date, use the date the user selected
    }

    // When setting a monthly reservation, we can use a fixed date or week+day style
    // If it's a fixed date, we need to set repeatingMonthWeek and repeatingMonthDay to null
    // If calculateEndDate gets values for repeatingMonthWeek and repeatingMonthDay, it will use those
    // If not, it will use the startDate as the date of the month for every month

    // We're setting a monthly reservation, and we've just toggled between a fixed date to a week+day style
    // Neither repeatingMonthWeek nor repeatingMonthDay can change at the same time repeatingMonthMethod changes
    if (currentValues.repeatingMonthMethod !== undefined) {
      const fixedMonthlyDate = currentValues.repeatingMonthMethod === "date" ? true : false;
      currentValues.repeatingMonthWeek = fixedMonthlyDate ? null : repeatingMonthWeek;
      currentValues.repeatingMonthDay = fixedMonthlyDate ? null : repeatingMonthDay;
    }

    // We're setting a monthly reservation, and we know if it's a fixed date or a week+day style, so set undefined if it's a fixed date
    // It's possible we've just be passed a new repeatingMonthWeek or repeatingMonthDay, so use those if available
    else {
      const fixedMonthlyDate = repeatingMonthMethod === "date" ? true : false;
      currentValues.repeatingMonthWeek = fixedMonthlyDate ? null : currentValues.repeatingMonthWeek || repeatingMonthWeek;
      currentValues.repeatingMonthDay = fixedMonthlyDate ? null : currentValues.repeatingMonthDay || repeatingMonthDay;
    }

    const newEndDate = calculateEndDate(
      currentValues.startDate            !== undefined ? currentValues.startDate : startDate,
      currentValues.repeatingFrequency   !== undefined ? currentValues.repeatingFrequency : repeatingFrequency,
      currentValues.repeatingGap         !== undefined ? currentValues.repeatingGap : repeatingGap,
      currentValues.repeatingOccurrences !== undefined ? currentValues.repeatingOccurrences : repeatingOccurrences,
      currentValues.repeatingMonthWeek   !== undefined ? currentValues.repeatingMonthWeek : repeatingMonthWeek,
      currentValues.repeatingMonthDay    !== undefined ? currentValues.repeatingMonthDay : repeatingMonthDay,
      currentValues.repeatingMonth       !== undefined ? currentValues.repeatingMonth : repeatingMonth,
      currentValues.repeatingDaysOfWeek  !== undefined ? currentValues.repeatingDaysOfWeek : repeatingDaysOfWeek,
    );
    console.log("calculated end date:", newEndDate);
    setRepeatingEndDate(newEndDate);
  };

  const handleChangeDateRange = (e) => {
    setDateRate({ startDate: e.startDate, endDate: e.endDate });
  };

  React.useEffect(() => {
    setDateRate({
      startDate: selectedDate && formatDateOfBirth(selectedDate[0]),
      endDate: selectedDate && formatDateOfBirth(selectedDate[selectedDate?.length - 1]),
    });
  }, []);

  const [calendarData, setCalendarData] = useState<any>();

  // Fetch vehicle calendar data
  useEffect(() => {
    const fetchCalendarData = async (vehicleId: string) => {
      try {
        const response = await vehicleApi.getVehicleCalendar({
          id: vehicleId,
          onlyActive: false,
        });
        setCalendarData(response.data.data);
      } catch (error: any) {
        console.error("Error fetching vehicle calendar data:", error);
      }
    };

    if (vehicleId) {
      fetchCalendarData(vehicleId);
    }
  }, [vehicleId]);

  const targetHistory = (!queryReservationId || !product) ? null : useTargetHistory(product, queryReservationId);
  console.log("targetHistory:", targetHistory);
  const initialSiteConstruction = React.useMemo(() => {
    if (targetHistory?.construction_id) {
      return targetHistory.construction_id.toString();
    }
    if (idConstuctionEmployeeSearch) {
      return idConstuctionEmployeeSearch.toString();
    }
    return "";
  }, [targetHistory?.construction_id, idConstuctionEmployeeSearch]);
  //console.log("targetHistory:", targetHistory);

  const reservationsInMonth = calendarData ? calculateReservationsInMonth(moment(queryStartDate).format("YYYY-MM"), calendarData) : [];
  //console.log("reservationsInMonth:", reservationsInMonth);
  const targetOccurrence = reservationsInMonth.find(reservation => (reservation.date === queryStartDate && reservation.fromTime === defaultStartTime));
  console.log("targetOccurrence:", targetOccurrence);
  const occurrenceComment = targetOccurrence ? (targetOccurrence.modificationComment ?? targetOccurrence.comment?.replace(/^⟳\s*/, "") ?? "") : targetHistory?.comment?.replace(/^⟳\s*/, "") ?? "";
  //console.log("defaultStartTime: ", defaultStartTime, ", occurrence time: ", defaultStartDate , ", occurrenceComment: ", occurrenceComment, "targetOccurrence:", targetOccurrence);

  const isOwner = targetHistory?.user_id === id;
  const isReturned = !targetHistory?.isBorrowing;
  const returnTime = calculateReturnTime(targetHistory);
  const returnMoment = moment(returnTime).toDate();
  const isLate = !isReturned && moment().isAfter(returnMoment);

  // combine targetOccurrence.date and targetOccurrence.toTime into a moment
  // This is the single day occurance of a recurring (or one time) reservation
  // Something can be not late, but still not editable if the current time is after the end time of the current occurance
  // If the final occurance end time has not passed, but the end time of this day's occurance has passed, the page shows it as not late, but also not editable.
  const occuranceEnd = targetOccurrence ? moment(`${targetOccurrence.date} ${targetOccurrence.toTime}`, "YYYY-MM-DD HH:mm:ss") : null;
  const isEditable = !isReturned && !moment().isAfter(occuranceEnd);
  //console.log("isOwner:", isOwner, ", returnTime:", returnTime, ", isLate:", isLate, ", isEditable:", isEditable);

  useEffect(() => {
    if (targetOccurrence) {
      //console.log("Setting startTime to ", moment(targetOccurrence.fromTime, ["HH:mm:ss", "h:mm a", "H:mm"]).format("HH:mm"), " and comment to ", targetOccurrence.modificationComment ?? targetOccurrence.comment ?? "");
      setStartTime(moment(targetOccurrence.fromTime, ["HH:mm:ss", "h:mm a", "H:mm"]).format("HH:mm"));
      setEndTime(moment(targetOccurrence.toTime, ["HH:mm:ss", "h:mm a", "H:mm"]).format("HH:mm"));
      setComment(occurrenceComment);
    }
  }, [calendarData]);

  const daysOfWeekToggles = <DaysOfWeekContainer>
    {repeatingDayOptions.map((day) => (
      <DayToggleButton
        key={day.value}
        selected={repeatingDaysOfWeek.includes(day.value)}
        onClick={() => {
          let newDaysOfWeek = [...repeatingDaysOfWeek];
          if (repeatingDaysOfWeek.includes(day.value)) {
            newDaysOfWeek = newDaysOfWeek.filter(d => d !== day.value);
          } else {
            newDaysOfWeek.push(day.value);
          }
          setRepeatingDaysOfWeek(newDaysOfWeek);
          updateEndDate({repeatingDaysOfWeek: newDaysOfWeek});
        }}
      >
        {day.shortLabel}
      </DayToggleButton>
    ))}
  </DaysOfWeekContainer>;

  const daysOfMonthElements = <ExecutionDateContainer>
    {/* date-based (日付指定) */}
    <ExecutionDateLabel>
      <input
        type="radio"
        name="repeatingMonthMethod"
        value="date"
        checked={repeatingMonthMethod === "date"}
        onChange={() => {
          setRepeatingMonthMethod("date");
          updateEndDate({repeatingMonthMethod: "date"});
        }}
      />
      <div className="label-text">
        <span>日にちで指定</span>
        <span>({moment(startDate).format("D")}日)</span>
      </div>
    </ExecutionDateLabel>

    {/* week-based (週+曜日指定) */}
    <ExecutionDateOption>
      <input
        type="radio"
        name="repeatingMonthMethod"
        value="week"
        checked={repeatingMonthMethod === "week"}
        onChange={() => {
          setRepeatingMonthMethod("week");
          updateEndDate({repeatingMonthMethod: "week"});
        }}
      />
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <AppCustomeSelect
          value={repeatingWeekOptions.find(o => o.value === repeatingMonthWeek) ?? null}
          options = {repeatingWeekOptions}
          onChange={(event) => {
            const newMonthWeek = event ? Number(event.value) || 1 : 1;
            setRepeatingMonthMethod("week");
            setRepeatingMonthWeek(newMonthWeek);
            updateEndDate({repeatingMonthWeek: newMonthWeek});
          }}
        />
        <AppCustomeSelect
          value={repeatingDayOptions.find(dayOption => dayOption.value === repeatingMonthDay) ?? null}
          options = {repeatingDayOptions}
          onChange={(event) => {
            const newMonthDay = event ? Number(event.value) || 1 : 1;
            setRepeatingMonthMethod("week");
            setRepeatingMonthDay(newMonthDay);
            updateEndDate({repeatingMonthDay: newMonthDay});
          }}
        />
      </div>
    </ExecutionDateOption>
  </ExecutionDateContainer>;

  return (
    <StyledVehicleDetailInfo>
      <div className="VehicleDetailInfo">
        <div className="infoTitle">
          <p className="infoTitleMain">{product?.title}</p>
          <div className="infoTitleSub">
            <p >{product?.category}</p>
          </div>
        </div>
        <Grid container>
          <Grid item xs={12} sm={12} md={12} lg={6} >
            <div className="info__detail">
              <div className="info__wrapper">
                <div className="info__imageWrapper">
                  <img
                    className="image"
                    src={linkImage(product?.img?.path)}
                    alt="detail product vehicle"
                  />
                </div>
              </div>
            </div>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={6}>
            <div className="info__infoWrapper">
              <span className="info__title">更新日時</span>
              <span className="info__number">
                {!!product?.lastUpdate &&
                  moment(product?.lastUpdate).format("YYYY/MM/DD・HH:mm")}
              </span>
            </div>
            <Divider />
            <div className="info__infoWrapper">
              <span className="info__title">車検</span>
              <span className="info__number">
                {!!product?.inspection_at &&
                  moment(product?.inspection_at).format("YYYY/MM/DD")}
              </span>
            </div>
            <Divider />
            <div className="info__infoWrapper">
              <span className="info__title">車検場所</span>
              <span className="info__number link">
                {product?.calibration_location}
              </span>
            </div>
            <Divider />

            {queryReservationId && (!isOwner || !isEditable) ? (
              <div className="info__user">
                <div className="row">
                  <Avatar src={linkAvatar(targetHistory?.user?.avatar?.path)} />
                  <p style={{ paddingLeft: "1rem" }}>
                    {targetHistory?.user?.last_name}
                    {targetHistory?.user?.first_name}
                  </p>
                </div>
                <div className="row">
                  <p>現場名</p>
                  <p style={{ paddingLeft: "1rem" }}>
                    {targetHistory?.construction?.name}
                  </p>
                </div>
                <div className="row">
                  <p>持出</p>
                  <p style={{ paddingLeft: "1rem" }}>
                    {targetHistory?.from} {targetHistory?.from_time ? moment(targetHistory.from_time, ["HH:mm:ss", "h:mm a", "H:mm"]).format("HH:mm") : ""}
                  </p>
                </div>
                <div className="row">
                  <p>返却</p>
                  <p style={{ paddingLeft: "1rem" }}>
                    {targetHistory?.to} {targetHistory?.to_time ? moment(targetHistory.to_time, ["HH:mm:ss", "h:mm a", "H:mm"]).format("HH:mm") : ""}</p>
                </div>
                <div className="row">
                  <p>補足メモ</p>
                  <p style={{ paddingLeft: "1rem" }}>{targetHistory?.comment}</p>
                </div>
              </div>
            ) : (
              <Formik
                initialValues={{
                  condition: "",
                  siteConstruction: initialSiteConstruction,
                }}
                enableReinitialize
                onSubmit={(values) => {
                  // updateConstructionSiteHistory(values?.siteConstruction);
                  const ignoreWeeksAndDays = (repeatingFrequency === "monthly" || repeatingFrequency === "yearly") && (repeatingMonthMethod === "date");

                  handleOnSubmit({
                    startDate: moment(startDate).format("YYYY-MM-DD"),
                    endDate: moment(endDate).format("YYYY-MM-DD"),
                    fromTime: moment(startTime, "HH:mm").format("HH:mm"), // The backend and database both use "from" and "to"
                    toTime: moment(endTime, "HH:mm").format("HH:mm"),
                    oldStart: queryStart,
                    quantity: 1,
                    vehicleItemId: product.id,
                    construction_id: values.siteConstruction,
                    comment: comment,
                    repeatingFrequency: repeatingFrequency,
                    repeatingGap: repeatingGap,
                    repeatingMonthWeek: ignoreWeeksAndDays ? undefined : repeatingMonthWeek,
                    repeatingMonthDay: ignoreWeeksAndDays ? undefined : repeatingMonthDay,
                    repeatingMonth: repeatingMonth,
                    repeatingDaysOfWeek: repeatingDaysOfWeek,
                    repeatingEndDate: repeatingEndMethod === "none" ? null : repeatingEndDate,
                    effectRange: queryEffectRange,
                    reservationId: queryReservationId,
                  });
                }}
                validationSchema={borrowingInstrumentSchema}
              >
                {({ handleSubmit, setFieldValue, values }) => {
                  const constructionOptions =
                    (optionSiteConstructions ?? []).map(item => ({
                      label: item.name,
                      value: item.id.toString(),
                    }));
                  const selectedOption = constructionOptions.find(o => o.value === values.siteConstruction) ?? null;

                  return (
                    <div className="info__form">
                      <div style={{ paddingBottom: "1rem" }}>
                        <p style={{ paddingBottom: "1rem" }}>
                          {LABEL_CONSTRUCTIONSITE /*現場名*/}
                        </p>
                        {!!optionSiteConstructions && (
                          <AppCustomeSelect
                            placeholder={PLACEHOLDER_CONSTRUCTIONSITE}
                            value={selectedOption}
                            onChange={(e) => {
                              setFieldValue(
                                "siteConstruction",
                                e.value
                              );
                              storeConstructionSelection({user_id: id, selected_construction_id: e.value });
                            }}
                            groupContructions={optionSiteConstructions}
                            options={
                              optionSiteConstructions?.length &&
                              optionSiteConstructions?.map(
                                (item) => {
                                  return {
                                    label: item.name,
                                    value: item.id.toString(),
                                  };
                                }
                              )
                            }
                            name="siteConstruction"
                          />
                        )}
                      </div>
                      <label className="label">
                        補足メモ
                      </label>
                      <AppTextArea
                        name="comment"
                        handleChange={(value) => {                          
                          setComment(value);
                        }}
                        value={comment}
                      />
                      <div style={{display: "none"}}>
                      <AppDateRangePicker
                        value={{
                          startDate: dateRate?.startDate,
                          endDate: dateRate?.endDate,
                        }}
                        onChange={(e) => handleChangeDateRange(e)}
                        startText="持出"
                        endText="返却"
                      />
                      </div>

                      <div style={{marginTop: "2rem", fontSize: "1.5rem", fontWeight: "bold", display: "flex"}}>
                        <span onClick={() => {if (canSelectNormal)    setReservationRepeating(false); setRepeatingFrequency("none");}} style={{width: "10rem", paddingBottom: "0.5rem", borderBottomWidth: "2px", borderBottomStyle: "solid", borderBottomColor: reservationRepeating ? "#ddd" : "#ed7330", textAlign: "center", cursor: canSelectNormal ?    "pointer" : "default", color: canSelectNormal ?    "inherit" : "#ccc", userSelect: "none", transition: "border-bottom-color 0.3s"}}>通常</span>
                        <span onClick={() => {if (canSelectRecurring) setReservationRepeating(true); }} style={{width: "10rem", paddingBottom: "0.5rem", borderBottomWidth: "2px", borderBottomStyle: "solid", borderBottomColor: reservationRepeating ? "#ed7330" : "#ddd", textAlign: "center", cursor: canSelectRecurring ? "pointer" : "default", color: canSelectRecurring ? "inherit" : "#ccc", userSelect: "none", transition: "border-bottom-color 0.3s"}}>繰り返し</span>
                      </div>

                      {/* Normal Reservation */}
                      <div style={{display: reservationRepeating ? undefined : undefined, marginTop: "1rem"}}>
                        <div>
                          <span>持出</span>
                          <DateTimeRow>
                            <DateTimeInputWrapper>
                              <DateTimeInput type="date" value={startDate} onChange={(event) => {setStartDate(event.target.value);}} />
                            </DateTimeInputWrapper>
                            <DateTimeInputWrapper>
                              <DateTimeInput type="time" value={startTime} onChange={(event) => { /*console.log("Setting to: " + event.target.value);*/ setStartTime(event.target.value);}} />
                            </DateTimeInputWrapper>
                          </DateTimeRow>
                        </div>
                        <div>
                          <span>返却</span>
                          <DateTimeRow>
                            <DateTimeInputWrapper hide={reservationRepeating}>
                              <DateTimeInput type="date" value={endDate} onChange={(event) => {setEndDate(event.target.value);}} />
                            </DateTimeInputWrapper>
                            <DateTimeInputWrapper>
                              <DateTimeInput type="time" value={endTime} onChange={(event) => {setEndTime(event.target.value);}} />
                            </DateTimeInputWrapper>
                          </DateTimeRow>
                        </div>

                        {/* Recurring Reservation */}
                        <div style={{display: reservationRepeating ? undefined : "none"}}>
                          {/* 繰り返し */}
                          <RepeatingGridContainer>
                            <RepeatingFrequencyWrapper>
                              <span style={{paddingBottom:"0.5rem"}}>繰り返し</span>
                              <AppCustomeSelect
                                placeholder={"選択"}
                                onChange={(event) => {
                                  setRepeatingFrequency(event.value);
                                  updateEndDate({repeatingFrequency: event.value});
                                }}
                                options={repeatingFrequencyOptions}
                                value={repeatingFrequencyOptions.find(option => option.value === repeatingFrequency)}
                              />
                            </RepeatingFrequencyWrapper>
                            {/* Frequency (gap), e.g. "every 3 days" or "every 2 months" */}
                            <div style={{display: (repeatingFrequency === "none" || repeatingFrequency === "yearly") ? "none" : undefined}}>
                              <span>繰り返す間隔</span>
                              <div style={{display: "flex", alignItems: "center", gap: "0.5rem"}}>
                                <AppInput
                                  isNumber
                                  value={repeatingGap.toString()}
                                  min={1}
                                  step={1}
                                  onChange={(event) => {
                                    //const endDate = calculateEndDate();
                                    const newFrequency = Math.max(1, Math.round(Number(event.target.value)) || 1);
                                    setRepeatingGap(newFrequency);
                                    updateEndDate({repeatingGap: newFrequency});
                                  }}
                                />
                                <span style={{width: "5rem"}}>{repeatingFrequencyOptions.find(option => option.value === repeatingFrequency)?.suffix}</span>
                              </div>
                            </div>
                            {/* Month selector for yearly */}
                            <div style={{display: repeatingFrequency === "yearly" ? "flex" : "none", flexDirection: "column"}}>
                              <span style={{paddingLeft: "1rem"}}>実行月</span>
                              <AppCustomeSelect
                                placeholder={"選択"}
                                onChange={(event) => {
                                  setRepeatingMonth(event.value);
                                  updateEndDate({repeatingMonth: event.value});
                                }}
                                options={repeatingMonths}
                                value={repeatingMonths.find(option => option.value === repeatingMonth)}
                              />
                            </div>
                          </RepeatingGridContainer>
                          {/* Day of the week selector */}
                          <div style={{display: repeatingFrequency === "weekly" ? "flex" : "none", flexDirection: "column"}}>
                            <span>曜日</span>
                            {daysOfWeekToggles}
                          </div>
                          {/* Date or week+day selector */}
                          <span style={{display: repeatingFrequency === "monthly" || repeatingFrequency === "yearly" ? undefined : "none"}}>実行日</span>
                          <ExecutionDateWrapper style={{display: repeatingFrequency === "monthly" || repeatingFrequency === "yearly" ? "flex" : "none"}}>
                            {daysOfMonthElements}
                          </ExecutionDateWrapper>
                          {/* Repeating end date */}
                          <span style={{display: repeatingFrequency === "none" ? "none" : undefined }}>終了日</span>
                          <EndMethodContainer style={{display: repeatingFrequency === "none" ? "none" : undefined}}>
                            <EndMethodLabel>
                              <input
                                type="radio"
                                name="endMethod"
                                value="none"
                                checked={repeatingEndMethod === "none"}
                                onChange={() => setRepeatingEndMethod("none")}
                              />
                              <span>指定なし</span>
                            </EndMethodLabel>
                            <EndMethodLabel>
                              <input
                                type="radio"
                                name="endMethod"
                                value="occurrences"
                                checked={repeatingEndMethod === "occurrences"}
                                onChange={() => {
                                  setRepeatingEndMethod("occurrences");
                                  updateEndDate({repeatingEndMethod: "occurrences"});
                                }}
                              />
                              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                <EndMethodNumberInput
                                  type="number"
                                  min={1}
                                  inputMode="numeric"
                                  value={repeatingOccurrences}
                                  onChange={(event) => {
                                    const newOccurrences = Math.max(1, Math.round(Number(event.target.value)) || 1);
                                    setRepeatingOccurrences(newOccurrences);
                                    setRepeatingEndMethod("occurrences");
                                    updateEndDate({repeatingOccurrences: newOccurrences});
                                  }}
                                  onFocus={() => {
                                    setRepeatingEndMethod("occurrences");
                                    updateEndDate({ repeatingEndMethod: "occurrences" });
                                  }}
                                  onClick={() => {
                                    setRepeatingEndMethod("occurrences");
                                    updateEndDate({ repeatingEndMethod: "occurrences" });
                                  }}
                                  aria-label="回数"
                                />
                                <span>回</span>
                              </div>
                            </EndMethodLabel>

                            <EndMethodLabel>
                              <input
                                type="radio"
                                name="endMethod"
                                value="date"
                                checked={repeatingEndMethod === "date"}
                                onChange={() => setRepeatingEndMethod("date")}
                              />
                              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                <EndMethodDateInput
                                  type="date"
                                  value={repeatingEndDate}
                                  onChange={(event) => {
                                    setRepeatingEndDate(event.target.value);
                                    setRepeatingEndMethod("date");
                                  }}
                                  onFocus={() => setRepeatingEndMethod("date")}
                                  onClick={() => setRepeatingEndMethod("date")}
                                  aria-label="終了日"
                                />
                                <span>まで</span>
                              </div>
                            </EndMethodLabel>
                          </EndMethodContainer>
                        </div>
                      </div>
                      <Divider />
                      <div className="btn" style={{width: "100%", maxWidth: "100%"}}>
                        <WideButton disabled={reservationRepeating && !validRepeatingInputs} onClick={() => handleSubmit()}>決定</WideButton>
                      </div>
                    </div>
                  );
                }}
              </Formik>
            )}
          </Grid>
        </Grid >
      </div >
    </StyledVehicleDetailInfo >
  );
};
